import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const StrategyGenie = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("StrategyGenie", "home/home_StrategyGenie_lang");
  }, [language]);

  const L = (componentLanguageData.StrategyGenie || { Main: {} }).Main;

  // 策略精靈 CTA 固定導向交易平台
  const signinUrl = "https://trade.masquant.com/authentication/sign-in";

  // icon 與文案分離：icon 與語系無關，文案由語言包提供
  const cards = [
    { icon: "bi-emoji-smile", title: L.Card1Title, desc: L.Card1Desc },
    { icon: "bi-clipboard-check", title: L.Card2Title, desc: L.Card2Desc },
    { icon: "bi-graph-up", title: L.Card3Title, desc: L.Card3Desc },
    { icon: "bi-moon-stars", title: L.Card4Title, desc: L.Card4Desc },
    { icon: "bi-hdd-stack", title: L.Card5Title, desc: L.Card5Desc },
    { icon: "bi-clock-history", title: L.Card6Title, desc: L.Card6Desc },
  ];

  const coreFeatures = [
    { title: L.Core1Title, desc: L.Core1Desc },
    { title: L.Core2Title, desc: L.Core2Desc },
    { title: L.Core3Title, desc: L.Core3Desc },
    { title: L.Core4Title, desc: L.Core4Desc },
    { title: L.Core5Title, desc: L.Core5Desc },
  ];

  return (
    <div className="container-xxl pt-5" id="strategy-genie">
      <div className="container">
        {/* 區塊標題 */}
        <div
          className="text-center mx-auto mb-5 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "760px" }}
        >
          <h5 className="text-primary text-uppercase">{L.Tag}</h5>
          <h1 className="display-6 mb-3">{L.Title}</h1>
          <p className="fs-5 fw-semibold mb-2">{L.Subtitle}</p>
          <p className="text-muted mb-0">{L.Desc}</p>
        </div>

        {/* 六大特色卡片 */}
        <div className="row g-4">
          {cards.map((c, i) => (
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay={`${0.1 + i * 0.1}s`}
              key={i}
            >
              <div className="genie-card h-100 p-4 rounded">
                <div className="genie-icon mb-3">
                  <i className={`bi ${c.icon}`}></i>
                </div>
                <h5 className="mb-2">{c.title}</h5>
                <p className="text-muted mb-0">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 影片 + 核心功能：沿用「從信任出發」區塊的 .ai_video 樣式，維持一致風格 */}
      <h3 className="text-center mt-5 mb-3 wow fadeInUp" data-wow-delay="0.1s">
        {L.VideoHeading}
      </h3>
      <p
        className="text-center text-muted mx-auto mb-2 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ maxWidth: "840px" }}
      >
        {L.VideoDesc}
      </p>
      <div className="ai_video pt-3">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-6">
              <iframe
                src={L.EmbedUrl}
                title={L.VideoHeading || "MAS Strategy Genie"}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                style={{ width: "100%", height: "500px" }}
              ></iframe>
            </div>
            <div className="col-md-6">
              <h2 className="section-title mt-3">{L.CoreHeading}</h2>
              <ul className="genie-core-list ai-check-list">
                {coreFeatures.map((f, i) => (
                  <li key={i}>
                    <span className="core-title">{f.title}</span>
                    <span className="core-desc">{f.desc}</span>
                  </li>
                ))}
              </ul>
              <a className="btn btn-primary btn-outline-primary" href={signinUrl}>
                {L.CTA}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrategyGenie;
